import { ReactNode } from 'react'
import { Script } from 'gatsby'
import { FooterContent, BannerContent } from 'shared-content'
import { Banner, Footer } from 'component-library'
import LinkComponent from '../LinkComponent/LinkComponent'
import MarkdownText from '../MarkdownText/MarkdownText'
import AuthProvider from '../AuthProvider/AuthProvider'
import NavBarWrapper from '../NavBarWrapper/NavBarWrapper'
import { getCurrentEnvConfig } from '../../../config'
import 'boxicons/css/boxicons.min.css'

interface ILayoutProps {
  children?: ReactNode
}

const Layout = ({ children }: ILayoutProps) => {
  const { widget_url } = getCurrentEnvConfig()

  return (
    <AuthProvider>
      <>
        <NavBarWrapper />
        {BannerContent.bannerText.length > 0 && (
          <Banner
            bannerText={<MarkdownText text={BannerContent.bannerText} />}
          />
        )}
        <div className="relative">{children}</div>
        <Footer
          footerDescription={
            <MarkdownText
              text={FooterContent.description}
              gaEventCategory="footer_ux"
              gaEventLabel="footer_xanadu_click"
              gaEventValue="redirect to xanadu homepage"
            />
          }
          {...FooterContent}
          LinkComponent={LinkComponent}
        />
        <Script src={widget_url} type="module" />
        {/* @ts-expect-error: Custom element not in JSX.IntrinsicElements */}
        <pennylane-help></pennylane-help>
      </>
    </AuthProvider>
  )
}

export default Layout
